import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import BackButton from "../../Components/BackButton";
import { Success, Error } from "../../Components/Modal";
import { useForm } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";
import { promoSchema } from "../../Schema/generalSchema";
import { useMutation, useQuery } from "react-query";
import { getAllUsers } from "../../Services/User";
import PromoForm from "./Components/PromoForm";
import { createPromoCode } from "../../Services/PromoCode";
import "../CMSManagement/CMSManagement.css";
import "./PromoCodes.css";

export default function AddPromoCode() {
    const navigate = useNavigate();
    const [image, setImage] = useState(null);
    const [preview, setPreview] = useState(null);

    const { register, handleSubmit, formState: { errors }, control, setValue, watch, trigger } = useForm({
        resolver: yupResolver(promoSchema),
        defaultValues: {
            status: "true",
            discountType: "percentage",
            firstOrderOnly: false,
            users: [],
            usagePerUser: "Unlimited",
            startDate: new Date().toISOString().split('T')[0]
        }
    });

    // Fetch Users for targeting
    const { data: userData } = useQuery(["all-users-promo"], () => getAllUsers(1, 1000));
    const users = userData?.data?.data?.docs || [];

    const { mutate, isLoading } = useMutation((formData) => {
        return createPromoCode(formData);
    }, {
        onSuccess: (res) => {
            Success("Promotion Created", res.data?.message || "The new promo code has been successfully published.");
            navigate("/promo-codes");
        },
        onError: (err) => Error(err?.response?.data?.message || "Failed to create promo code.")
    });

    const handleImageChange = (e) => {
        const file = e.target.files[0];
        if (file) {
            setImage(file);
            setPreview(URL.createObjectURL(file));
        }
    };

    const onSubmit = (data) => {
        const formData = new FormData();

        // Manual mapping to match backend fields
        formData.append("typeName", "promoCodes");
        formData.append("promoCode", data.promoCode);
        formData.append("discountType", data.discountType);
        formData.append("value", data.discountValue);
        formData.append("minOrderValue", data.minOrderValue || 0);
        formData.append("maxDiscountCap", data.maxDiscountCap || 0);
        formData.append("applyOnUsers", JSON.stringify(data.users || []));
        formData.append("firstOrderOnly", data.firstOrderOnly);
        formData.append("usageLimitGlobal", data.usageLimit || 0);
        formData.append(
            "usageLimitPerUser",
            data.usageLimitPerUser === null || data.usageLimitPerUser === undefined ? 1 : data.usageLimitPerUser
        );
        formData.append("startDate", data.startDate);
        formData.append("expiryDate", data.expiryDate);
        formData.append("visibilityStatus", data.status === "true" ? "active" : "inactive");

        if (image) formData.append("promoBanner", image);

        mutate(formData);
    };

    return (
        <div className="app-content content promo-page">
            <div className="content-wrapper">
                <div className="content-body">
                    <section id="add-promo-code">
                        <div className="user-details-wrapper">
                            <div className="promo-page-header">
                                <div className="back-title d-flex align-items-center mb-2">
                                    <BackButton />
                                    <h1 className="promo-page-header__title ms-3">Create New Promotion</h1>
                                </div>
                                <p className="promo-page-header__subtitle ms-5 ps-2">
                                    Set up discount codes, target users, and schedule visibility
                                </p>
                            </div>

                            <PromoForm
                                register={register}
                                handleSubmit={handleSubmit}
                                errors={errors}
                                control={control}
                                onSubmit={onSubmit}
                                isLoading={isLoading}
                                preview={preview}
                                handleImageChange={handleImageChange}
                                users={users}
                                setValue={setValue}
                                watch={watch}
                                trigger={trigger}
                            />
                        </div>
                    </section>
                </div>
            </div>
        </div>
    );
}
